import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { getModelDocDownloadUrl } from '@/utils/utils';

const ModelProposalDownload = ({ identifier }) => {
  const { t } = useTranslation('proposalRequest');
  
  return (
    <a href={getModelDocDownloadUrl(identifier)} target="_blank" className="truncate inline"
      rel="noreferrer">
      <span className="cursor-pointer text-primary" title={t('proposalRequest.form.general.statutes.help')}>
        {t('proposalRequest.form.general.statutes.actionLabel')}
      </span>
    </a>
  );
};

ModelProposalDownload.propTypes = {
  identifier: PropTypes.string,
};

export default memo(ModelProposalDownload);
